<template>
    <div class="infoList">
        <div class="infoList-title"><span>{{ data.listData.title }}</span> <span @click="moreClicks">更多<DoubleRightOutlined /></span></div>
        <div class="infoList-card" v-for="(item, i) in data.listData.list" :key="i">
            <div class="infoList-card-img">
                <img :src="data.internalInstance.appContext.config.globalProperties.$imgUrl + item.imgs" alt="商品图片">
            </div>
            <div class="infoList-card-text" @click="handleClick(item.id)">
                <p class="infoList-top" v-if="item.isTop">置顶</p>
                <p class="infoList-card-text-title">{{ item.title }}</p>
<!--                <p class="infoList-card-text-content">{{ item.content }}</p>-->
<!--                <p class="infoList-card-text-size">{{ item.size }}</p>-->
                <p class="infoList-card-text-size">{{ item.address }}</p>
                <p class="infoList-card-text-size">{{ item.createTime ? item.createTime.split(' ')[0] : '' }} ~ {{ item.effectiveTime ? item.effectiveTime.split(' ')[0] : '' }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive, onMounted, getCurrentInstance } from 'vue'
import DoubleRightOutlined from '@ant-design/icons-vue/lib/icons/DoubleRightOutlined'
export default {
    name: "infoListCard",
    props: {
        listData: Object
    },
    setup(props, {emit}) {
        const data = reactive({
            listData: {
                listData: {
                    title: ''
                }
            },
            internalInstance: getCurrentInstance()
        })
        const handleClick = (id) => {
            emit('infoListCardClick', id)
        }
        const moreClicks = () => {
            emit('moreClick')
        }
        onMounted(() => {
            data.listData = props.listData
            console.log(props.listData)
        })
        return {
            data,
            handleClick,
            moreClicks
        }
    },
    components: {
        DoubleRightOutlined
    }
}
</script>

<style scoped lang="stylus">
    .infoList {
        width 100%
        background-color #FFF
        padding 10px 25px
        margin 10px 0
        .infoList-title {
            width 100%
            height 18px
            line-height 18px
            border-left 3px solid #44A73D
            padding-left 5px
            color #222
            font-size 14px
            font-weight bolder
            display flex
            justify-content space-between
            margin-bottom 17px
        }
        .infoList-title span {
            display inline-block
        }
        .infoList-title span:last-child {
            color #44A73D
            position relative
            right 0
            font-size 12px
        }
        .infoList-card {
            width 100%
            height 75px
            box-shadow 0 3px 6px rgba(0, 0, 0, 0.07)
            margin-bottom 7px
            display flex
            flex-wrap nowrap
            .infoList-card-img {
                width 75px
                height 100%
                background-color #76C274
                overflow hidden
                border-radius 1px
            }
            .infoList-card-img img {
                width 100%
                height 100%
                object-fit cover
            }
            .infoList-card-text {
                width calc(100% - 75px)
                height 100%
                padding 2px 10px
                position relative
                .infoList-top {
                    position absolute
                    right 10px
                    top 5px
                    color #ff0000
                    font-size 12px
                }
                .infoList-card-text-title {
                    font-size 16px
                    color #222
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                    margin-bottom 10px
                }
                .infoList-card-text-content {
                    font-size 16px
                    color #E9891C
                }
                .infoList-card-text-size {
                    font-size 12px
                    color #6A6A6A
                }
            }
        }
    }
</style>